import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ResetDemoAccountResponse {
  data: {
    message: string;
    successful: number;
    failed: number;
    total: number;
  };
  statusCode: number;
  statusReponse: string;
  success: boolean;
}

async function resetDemoAccount(
  subscriptionId: string,
  auth: Authentication | null,
  datasetFilename?: string,
): Promise<ResetDemoAccountResponse> {
  try {
    if (!auth) throw new ResetDemoAccountFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const query = datasetFilename
      ? `?${new URLSearchParams({ dataset_filename: datasetFilename }).toString()}`
      : '';

    const response = await HttpClient.get(
      `/backoffice/demoaccount/${subscriptionId}/reset${query}`,
      auth.token
    );

    return response;
  } catch (e) {
    if (e instanceof ResetDemoAccountFailure) throw e;
    // HttpClient throws plain Error; preserve message so the UI can show it
    const errMessage =
      e instanceof Error
        ? e.message
        : typeof e === 'string'
          ? e
          : 'Une erreur inattendue s’est produite.';
    throw new ResetDemoAccountFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class ResetDemoAccountFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default resetDemoAccount;
